import * as React from "react";
const SvgFiRrVideoArrowUpRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14 11v3a1 1 0 0 1-2 0v-2.586l-4.293 4.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L10.586 10H8a1 1 0 0 1 0-2h3c1.654 0 3 1.346 3 3m10-2.687v7.319c0 .756-.42 1.437-1.097 1.775a1.979 1.979 0 0 1-2.078-.188 1 1 0 0 1-.106-.092l-1.756-1.754c-.194 2.581-2.333 4.628-4.962 4.628H5c-2.757 0-5-2.243-5-5v-6c0-2.757 2.243-5 5-5h9c2.618 0 4.748 2.029 4.959 4.594l1.756-1.772q.052-.052.11-.096a1.98 1.98 0 0 1 2.078-.188A1.98 1.98 0 0 1 24 8.314zM17 9c0-1.654-1.346-3-3-3H5C3.346 6 2 7.346 2 9v6c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3zm5.025 6.605L22 8.366l-3 3.028v1.189z"
    />
  </svg>
);
export default SvgFiRrVideoArrowUpRight;
